import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TeamCompiPage from "./TeamCompiPage";
import SoloCompiPage from "./SoloCompiPage";

const MainCompiPage = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { compId } = params;

  const [competition, setCompetition] = useState({});

  const fetchCompetitionDetails = () => {
    Axios.get(
      `https://ashish.moodi.org/competitions/get_compi_details?id=${compId}`
    )
      .then((res) => setCompetition(res.data))
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    if (localStorage.getItem("compiauthtoken")) {
      fetchCompetitionDetails();
    } else {
      navigate("/admin/login");
    }
    // eslint-disable-next-line
  }, []);
  return (
    <div className="container-fluid">
      {competition.isTeamCompi ? (
        <TeamCompiPage
          competition={competition}
          setCompetition={setCompetition}
        />
      ) : (
        <SoloCompiPage
          competition={competition}
          setCompetition={setCompetition}
        />
      )}
    </div>
  );
};

export default MainCompiPage;
